import {
  NavLink
} from "react-router-dom";
import { withTheme, css } from '@emotion/react'
import styled from '@emotion/styled';

const SubLink = styled(NavLink)`
  cursor: pointer;
  color: ${props => props.theme.colors.primary4};
  display: inline-block;
  padding: 8px;
  text-decoration: none;
  transition: all 0.25s ease;
  width: 100%;
  border-radius: 4px;

  &:hover {
    ${props => !props.isMobile && css`background-color: #d2f1fc;`};
  }
`;

const SubLinkText = styled.span`
  color: ${props => props.theme.colors.primary4};
  display: inline-block;
  padding-bottom: 8px;
  text-decoration: none;
`;

const SubDesc = styled.p`
  color: ${props => props.theme.colors.neutral1};
  font-family: ${props => props.theme.fonts.secondary};
  font-size: ${props => props.theme.fontSizes.xs};
  font-weight: normal;
  line-height: ${props => props.theme.lineHeights.sm};
`;

const SubItem = styled.li`
  background: ${props => props.theme.colors.contrast2};
  padding: 12px 0;

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    padding: 12px;
  }
`;

const StyledList = styled.ul`
  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: transparent;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 10px 0px;
    font-weight: normal;

    &:after {
      box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.06);
      content: "";
      display: block;
      height: 10px;
      position: absolute;
      top: -10px;
      width: 280px;
    }
  }
`;

function PatientsMenu() {
  return (
    <StyledList>
      <SubItem>
        <SubLink to="/patients/what-is-studykik">
          <SubLinkText>What is StudyKIK?</SubLinkText>
          <SubDesc>Learn how we connect people like you with research studies.</SubDesc>
        </SubLink>
      </SubItem>
      <SubItem>
        <SubLink to="/patients/what-are-clinical-trials">
          <SubLinkText>What are Clinical Trials?</SubLinkText>
          <SubDesc>Thinking of joining a clinical trial? Here’s a great place to start.</SubDesc>
        </SubLink>
      </SubItem>
      <SubItem>
        <SubLink to="/">
          <SubLinkText>Find a Clinical Trial</SubLinkText>
          <SubDesc>Instantly find a clinical trial near you</SubDesc>
        </SubLink>
      </SubItem>
    </StyledList>
  )
}

export default withTheme(PatientsMenu);